import { useAuthQuery } from 'app/api_v2/auth/queries';
import { AppState } from 'app/store';
import { setAuthData } from 'app/store/auth';
import { SplashScreen } from 'app/ui/components/SplashScreen';
import rg4js from 'raygun4js';
import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isRaygunEnabled } from '../errors/errors.lib';

interface CheckIsLoggedInGuardProps {
  children: ReactNode;
}

export const CheckIsLoggedInGuard = (props: CheckIsLoggedInGuardProps) => {
  const { children } = props;

  const { isLoading, isError, isSuccess, data } = useAuthQuery({ retry: false });
  const dispatch = useDispatch();

  const user = useSelector(({ auth }: AppState) => auth.user);

  useEffect(() => {
    if (isSuccess && data) {
      // if user is not already set, set auth data
      if (!user?.id) {
        dispatch(setAuthData(data));
        if (isRaygunEnabled()) {
          rg4js('setUser', {
            identifier: data.email, // A unique ID, email address, or another ID such as a UUID
            isAnonymous: false, // Indicates whether the user is anonymous or not
            uuid: data.id, // Optional device identifier
          });
        }
      }

      // when user changed in other window or tab, reload the page
      if (user?.id && user?.id !== data.id) {
        window.location.reload();
      }
    }
  }, [isSuccess, data, JSON.stringify(data), dispatch]);

  if (isLoading && !isError) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};

export default CheckIsLoggedInGuard;
